import { PureComponent } from 'react';
import UIDialog from 'UIComponents/dialog/UIDialog';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import styled from 'styled-components';
import { logCallingError } from 'calling-error-reporting/report/error';
import { TWILIO_WIDGET_OPTIONS } from 'calling-lifecycle-internal/constants/twilioWidgetOptions';
import InternalWidgetError from './InternalWidgetError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallingWidgetError__Wrapper",
  componentId: "sc-1g9750l-0"
})(["position:fixed;top:60px;right:20px;width:", "px;box-shadow:0 0 10px rgba(0,0,0,0.5);"], TWILIO_WIDGET_OPTIONS.width);
class CallingWidgetError extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleHideWidget = () => {
      this.props.onSetIsWidgetHidden(true);
    };
  }
  componentDidMount() {
    const {
      error,
      appName
    } = this.props;
    if (error) {
      logCallingError({
        errorMessage: 'Error caught in async bundle',
        extraData: {
          error,
          appName
        },
        tags: {
          component: 'AsyncCallingWidget'
        }
      });
    }
  }
  render() {
    const {
      isWidgetHidden
    } = this.props;
    if (isWidgetHidden) {
      return null;
    }
    return /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsxs(UIDialog, {
        className: "call-communicator-error",
        children: [/*#__PURE__*/_jsx(UIDialogHeader, {
          className: "communicator-header",
          children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: this.handleHideWidget
          })
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          className: "p-bottom-4",
          children: /*#__PURE__*/_jsx(InternalWidgetError, {})
        })]
      })
    });
  }
}
export default CallingWidgetError;